import { Action } from '@ngrx/store';
import { ActionOptionsArgs, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { ControlType } from './control-type.model';

export const ENTITY = 'controlType';
export const SUBMIT = '[ControlType] Submit';
export const REHYDRATE = '[ControlType] Rehydrate';
export const REMOVE = '[ControlType] Remove';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: ControlType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<ControlType>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: ControlType, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/control-type/control-type.actions.ts